module.exports = __webpack_public_path__ + "static/media/footer_popup_whatsapp_icon.a51db212.svg";